/**
 * Agregar al carrito desde las cards de recomendados.
 *
 * Usa la misma via que el resto del tema: se agrega con /cart/add.js y luego se
 * pide /cart?view=compare para entregarle el carrito al drawer Vue, que vuelve
 * a renderizar. Reemplaza el flujo anterior, que simulaba clicks en el boton
 * "+" de una linea del carrito y despues corregia la cantidad a mano.
 */
(function () {
  var routes = window.wayuCartRoutes || {};
  var CART_ADD_URL = routes.add || '/cart/add.js';
  var CART_COMPARE_URL = routes.compare || '/cart?view=compare';

  var ADD_LABEL = 'AGREGAR AL CARRO';
  var adding = false;

  // Refresca el drawer con el carrito actual. Reutiliza el helper del snippet
  // right-drawer si ya esta definido para no duplicar la logica.
  function refreshCartDrawer() {
    if (window.refreshCartDrawer) return window.refreshCartDrawer();

    return fetch(CART_COMPARE_URL, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('No se pudo obtener el carrito');
        return response.json();
      })
      .then(function (cart) {
        if (window.wetheme && window.wetheme.toggleRightDrawer) {
          window.wetheme.toggleRightDrawer('cart', true, { cart: cart });
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('wetheme-toggle-right-drawer', {
              detail: { type: 'cart', forceOpen: true, params: { cart: cart } }
            })
          );
        }
        return cart;
      });
  }

  function addVariant(variantId) {
    return fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (response) {
      if (response.ok) return response.json();

      // Shopify explica el motivo real en el cuerpo (agotado, limite por pedido, etc.)
      return response
        .json()
        .catch(function () { return {}; })
        .then(function (body) {
          throw new Error(
            'variante ' + variantId + ': ' + (body.description || body.message || response.status)
          );
        });
    });
  }

  /**
   * Agrega un recomendado al carrito y refresca el drawer.
   * @param {number} variantId variante a agregar
   * @param {Event} [event] click, para dar feedback en el boton
   */
  window.addToCart = function (variantId, event) {
    if (adding) return;

    var button = event && event.target ? event.target.closest('.reco-add-btn') : null;
    var label = button ? button.querySelector('.reco-add') : null;

    adding = true;
    if (button) button.disabled = true;
    if (label) label.textContent = 'AGREGANDO...';

    addVariant(variantId)
      .then(refreshCartDrawer)
      .catch(function (error) {
        console.error('No se pudo agregar el recomendado (' + error.message + ')');
        if (label) label.textContent = 'ERROR';
      })
      .then(function () {
        adding = false;
        if (button) button.disabled = false;
        // El drawer puede haberse re-renderizado; si el boton sigue vivo, se restaura.
        if (label && label.isConnected) label.textContent = ADD_LABEL;
      });
  };

  // Misma operacion desde fuera del drawer (seccion de recomendados en la PDP):
  // refreshCartDrawer ya abre el carrito lateral.
  window.addToCartAndOpenDrawer = function (variantId) {
    window.addToCart(variantId);
  };
})();
